import XTbl, {Xtc} from '../../components/new-x-table/index';

const tbl = new XTbl('/personnel/table/delete', 'لیست درخواست ها');
tbl.add(new Xtc('id', 'شناسه').filterText());
tbl.add(new Xtc('name', 'نام و نام خانوادگی').filterText());
tbl.add(new Xtc('ncode', 'کد ملی').filterText())
tbl.add(new Xtc('caj', 'ثبت نام').filterDate())
tbl.add(new Xtc('uaj', 'به روز رسانی').filterDate().filterKey('updated_at'))
tbl.add(new Xtc('id', 'عملیات').renderSlot('operator'))
/*tbl.addOpt()*/

export default tbl;
